import { render } from "./Blog.vue?vue&type=template&id=523b1038&scoped=true&ts=true"
import script from "./Blog.vue?vue&type=script&lang=ts"
export * from "./Blog.vue?vue&type=script&lang=ts"

import "./Blog.vue?vue&type=style&index=0&id=523b1038&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-523b1038"]])

export default __exports__